<style>
</style>
<template>
<div>
  <v-dialog v-model="alertDialog" max-width="400">
    <v-card>
      <v-card-title>
        <div class="headline red--text">{{ $t('Upozornění') }}</div>
      </v-card-title>
      <v-card-text>
        <div class="title">{{ $t($error.dialogResponse) }}</div>
        <div class="caption">{{ $t($error.errorText) }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="resetStatus()">{{ $t('Zavřít') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
  mixins: [TransformMixin],
  computed: {
    alertDialog() {
      return this.$error.hasStatus
    }
  },
  methods: {
    resetStatus() {
      this.$error.error.status = null
    }
  }
}
</script>
